// styles
import {
  AwardsWrapper,
  LogosSlider,
  LogosList,
  Logo,
  TagLine,
  Tag,
  ContainerTag,
} from './Awards.styles';

export function Awards({ awards_content }) {
  const sliderspeed = awards_content.items.length * 4;

  return (
    <>
      <ContainerTag>
        <Tag>{awards_content.tag}</Tag>
        <TagLine>{awards_content.title}</TagLine>
      </ContainerTag>

      <AwardsWrapper>
        <LogosSlider className="logoslider">
          <LogosList className="logoslider-list" items={sliderspeed}>
            {awards_content.items.map((item, key) => {
              return (
                <Logo key={key + '-a-' + item.title.trim()}>
                  <span className="year">{item.year}</span>
                  <span className="title">{item.title}</span>
                  <span className="source">{item.source}</span>
                </Logo>
              );
            })}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {awards_content.items.map((item, key) => {
              return (
                <Logo key={key + '-b-' + item.title.trim()}>
                  <span className="year">{item.year}</span>
                  <span className="title">{item.title}</span>
                  <span className="source">{item.source}</span>
                </Logo>
              );
            })}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {awards_content.items.map((item, key) => {
              return (
                <Logo key={key + '-c-' + item.title.trim()}>
                  <span className="year">{item.year}</span>
                  <span className="title">{item.title}</span>
                  <span className="source">{item.source}</span>
                </Logo>
              );
            })}
          </LogosList>
        </LogosSlider>
      </AwardsWrapper>
    </>
  );
}
